import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as Cookies from 'js-cookie';
import 'MagnificPopup';
import { wcagOptions } from "./wcag";
import { bookingFormCommon } from "./c005-bookingform-common";

export class newsletterWidget{
	private $newsletterEmail: string = '';
	private $newsletterError:Array<string> = [];
	private wcag = new wcagOptions();

	$scope: any = $('.newsletter-popup');
	$newsletterValidator: any = $('#newsletterWidgetEmail-validator');
	$newsletterEmailInput: any = $('#newsletterWidgetEmail');
	$newsletterPreferredCity: any = $('#newsletterPreferredCity');
	$newsletterCheckbox: any = $('#newsletterTandC');
	$newsletterSubmitBtn: any = $('.newsletter-btn');
	$newsletterErrorValidation: any = $('.newsletteremail-error--validation');
	$newsletterPopUpConsent: any = $('#newsletterPopUpChk');

	$error:Array<any>;

	newsletterPopUpInit(): void {
		var idleTime = 0;
		$(document).ready(function () {
			let $isEnableNewsLetter: any = $('#isEnableNewsLetterPopup');
			if (($isEnableNewsLetter.val() != 'null') && ($isEnableNewsLetter.val() != '0') && ($isEnableNewsLetter.val() != '')) {
				let timeDelay: any = $('[data-newsletter-popup-delay]').attr('data-newsletter-popup-delay') != '' ? $('[data-newsletter-popup-delay]').attr('data-newsletter-popup-delay') : '30000';
				var idleInterval = setInterval(timerIncrement, timeDelay);
				// if (!Cookies.get('newsletter-shown')) {
				// 	$.magnificPopup.open({
				// 		items: {
				//     		src: '#newsletter-popup'
				//     	},
				//     	type: 'inline',
				// 		midClick: false,
				// 		enableEscapeKey: false
				// 	});
				// 	Cookies.set('newsletter-shown', true, {expires: 365});
				// }
			}
		});

		function resetTimer() {
			idleTime = 0;
		}
		function timerIncrement() {
			let $isEnableNewsLetter: any = $('#isEnableNewsLetterPopup');
			if (($isEnableNewsLetter.val() != 'null') && ($isEnableNewsLetter.val() != '0') && ($isEnableNewsLetter.val() != '')) {
				idleTime = idleTime + 1;
				if (idleTime >= 1) {
					let checkfor_popup = $.magnificPopup.instance.isOpen;
					if (!Cookies.get('newsletter-not-show') && !checkfor_popup) {
						$.magnificPopup.open({
							items: {
								src: '#newsletter-popup'
							},
							type: 'inline',
							midClick: false,
							enableEscapeKey: false,
							callbacks: {
								close: function () {
									let $newsletterConsent = $('#newsletter-popup #newsletterPopUpChk').is(':checked');
									if ($newsletterConsent) {
										Cookies.set('newsletter-not-show', true, { expires: 365 });
									}
								}
							}
						});
						idleTime = 0;
					}
				}
				$(window).unbind();
			}
		}
		$(document)
			.on('mousemove', resetTimer)
			.on('keydown', resetTimer)
			.on('scroll', resetTimer);


		if (Cookies.get('newsletter-success', true)) {
			$.magnificPopup.open({
				items: {
		    		src: '#newsletter-popup--success'
		    	},
		    	type: 'inline',
				midClick: false,
				enableEscapeKey: false
			});

			let $newsletterSuccess: any = $('#newsletter-popup--success');
			let $newsletterSuccessTitle: any = $newsletterSuccess.find('h3');
			let $newsletterSuccessSpan: any = $newsletterSuccess.find('.email-details span.email-txt');
			let $newsletterSuccessText: any = $newsletterSuccess.find('.email-details p');
			if (window.location.search.indexOf('acemail=exist') > -1) {
				let $dataAcemailExist:any = $newsletterSuccess.attr('data-acemail-exist');
				let $dataAcemailExistSpan:any = $newsletterSuccess.attr('data-acemail-existspan');
				let $dataAcemailExistText:any = $newsletterSuccess.attr('data-acemail-existtext');
				$newsletterSuccessTitle.text($dataAcemailExist);
				$newsletterSuccessSpan.text($dataAcemailExistSpan);
				$newsletterSuccessText.text($dataAcemailExistText);
			} else if (window.location.search.indexOf('acemail=new') > -1){
				let $dataAcemailNew:any = $newsletterSuccess.attr('data-acemail-new');
				let $dataAcemailNewSpan:any = $newsletterSuccess.attr('data-acemail-newspan');
				let $dataAcemailNewText:any = $newsletterSuccess.attr('data-acemail-newtext');
				$newsletterSuccessTitle.text($dataAcemailNew);
				$newsletterSuccessSpan.text($dataAcemailNewSpan);
				$newsletterSuccessText.text($dataAcemailNewText);
			} else if (window.location.search.indexOf('acemail=false') > -1){
				$.magnificPopup.open({
					items: {
			    		src: '#newsletter-popup--notsuccess'
			    	},
			    	type: 'inline',
					midClick: false,
					enableEscapeKey: false
				});
			}
			Cookies.set('newsletter-success', '');
			let $getEmailValue:any = Cookies.get('userEmail');
			$('.newsletter-popup--success .email-details span.email-address a').html($getEmailValue);
			$('.newsletter-popup--success .email-details span.email-address a').attr("href", "mailto:" +$getEmailValue);
		}
	}

	preferredcitylist(): any {
		let defer:any = $.Deferred();
		$.get('/content/mas-admin/ond/getService.Newsletter.json')
		.done((data:any) => {
			var dataParse:any = null;
			if (typeof data === 'string') {
				dataParse= JSON.parse(data);
			}
			else {
				dataParse = data;
			}
			var airportListResponse = dataParse.response;
			var listItems = "<option value=''> </option>";
			for (var key in airportListResponse) {
				listItems += "<option value='" + airportListResponse[key].airportCode + "'>" + airportListResponse[key].airportName + ", " + airportListResponse[key].countryName + " (" + airportListResponse[key].airportCode + ")" +"</option>";
			}

			defer.resolve(listItems);
		})
		.fail((error:any) => {
			defer.reject(error);
		});
		return defer.promise();
	}

	validateEmail($newsletterEmail:string): boolean {
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
				return emailReg.test($newsletterEmail);
	}

	newsLetterError(): void {
		var _this = this;
		_this.$error = [];
		$('.newsletteremail-error--validation').show();
		$('#newsletterWidgetEmail-validator').addClass('has-error');
		var $newsletterError = "Oops! Your request was unsuccessful. Please try again.";
		_this.$error.push($newsletterError);
		$("#newsletterWidgetEmail-validator").text(_this.$error.join(', '));
	}

	submitNewsletterForm(newsLetterEmail:string, preferredCity:string):any {
		var _this = this;
		document.cookie = "userEmail="+newsLetterEmail +";path=/";
		if (preferredCity && preferredCity!='') {
			document.cookie = "preferredCity="+preferredCity+";path=/";
		}
		
		let lang_js = "";
    let country_js = "";
    let url = window.location.href;
    let splittedUrl = url.split("/");
  	country_js = splittedUrl[3];
		let lan = "";
		if(splittedUrl[4] && splittedUrl[4].indexOf('?') > -1) {
			lan = splittedUrl[4].substring(0, splittedUrl[4].indexOf('?'));
			lang_js = lan.replace(".html","");
		} else {
			lang_js = splittedUrl[4].replace(".html","");
		}
		var $data = {
			email: newsLetterEmail,
			city: '',
			action:'manage',
			language:lang_js,
			country:country_js
		};
		if (preferredCity != '') {
			$data['city'] = preferredCity;
			$data['action'] = 'create';
		}

		let _self = this;

		if (_self.getUrlVars("acemail") && (_self.getUrlVars("acemail")=="new" ||
			 (_self.getUrlVars("acemail")=="resignup" && _self.getUrlVars("profile")=="new"))) {
				$data['action'] = 'create';
				$data['resendtrue'] = 'true';
				$data['city'] = _this.readValueFromCookie('preferredCity');
		} else if (_self.getUrlVars("acemail") && (_self.getUrlVars("acemail")=="exist" || _self.getUrlVars("acemail")=="resignup")) {
			$data['action'] = 'exist';
		} else if (_self.getUrlVars("acappexec") && _self.getUrlVars("acappexec")=="true") {
			$data['action'] = 'acappexec';
		}

		$.ajax({
			type: 'POST',
			url: '/bin/services/new/newsletter',
			data: $data,
			success: function(json:any){
				json = JSON.parse(json);
				console.log("##Successful: " + json);
				if (json.success==true) {
					console.log("Success"+ json);
					if (json.redirectURL) {
						window.location.replace(json.redirectURL);
					} else {
						$('.newsletter-widget--success .email-details > span > a').attr('href',"mailto:" + newsLetterEmail);
						$('.newsletter-widget--success .email-details > span > a').text(newsLetterEmail);
						$('.newsletter-widget--success').show();
						$('.newsletter-widget--holder').hide();
						$('.newsletter-container').scrollIntoView();
					}
				} else {
					console.log("Error while submitting form" + json);
					_this.newsLetterError();
				}
			},
			error: function(error:any) {
				console.log("Error while submitting form", error);
			}
		});
	}

	getUrlVars(url:string):any {
		let vars:Array<any> = [];
		let hash:any;
		let hashes = url.slice(url.indexOf('?') + 1).split('&');
		for(let i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}

	initSelectize(listItems: string): void {
		let _self = this;

		let $preferredCitySel: any = $('#newsletterPreferredCity');
		let $preferredCity   : any = $('.newsletterPreferredCity');
		$preferredCitySel.html(listItems);
		$preferredCitySel.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($preferredCitySel[0].selectize);
			},
			onFocus: function() {
				$preferredCity.find('.booking-form--title').addClass('input-filled');
				$preferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$preferredCitySel.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$preferredCitySel.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
				$preferredCity.find('.booking-form--title').addClass('input-filled');
				$preferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
			},
			onBlur: function(){
				let $preferredCityChange = $preferredCitySel.find('option:selected').text();
				if ($preferredCityChange == ''){
					$preferredCity.find('.booking-form--title').removeClass('input-filled');
					$preferredCity.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$preferredCity.find('.booking-form--title').addClass('input-filled');
					$preferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			}
		});
	}

	newsletterForm(): any {
		let _self = this;
		if (_self.$scope.length == 0) { return; }

		_self.$newsletterSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			this.$newsletterError = [];
			_self.$newsletterErrorValidation.show();

			let $newsletterEmail = _self.$newsletterEmailInput.val();

			if ((!(this.validateEmail($newsletterEmail))) || $newsletterEmail == ''){
				let $newsletterEmailValidate:any = _self.$newsletterEmailInput.attr('data-email');
				this.$newsletterError.push('<strong>'+_self.$newsletterEmailInput.parent().find('.booking-form--title').text()+':</strong> '+$newsletterEmailValidate);
				_self.$newsletterEmailInput.addClass('has-error');
				_self.$newsletterEmailInput.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$newsletterEmailInput.removeClass('has-error');
				_self.$newsletterEmailInput.parent().find('.booking-form--title').removeClass('has-error');
			}

			if (_self.$newsletterPreferredCity.val() == ''){
				_self.$newsletterPreferredCity.parent().find('.selectize-control .selectize-input').addClass('has-error');
				_self.$newsletterPreferredCity.parent().find('.booking-form--title').addClass('has-error');
				let $preferredCityValidate:any = _self.$newsletterPreferredCity.attr('data-preferredcity');
				this.$newsletterError.push('<strong>'+_self.$newsletterPreferredCity.parent().find('.booking-form--title').text()+':</strong> '+$preferredCityValidate);
			} else {
				_self.$newsletterPreferredCity.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				_self.$newsletterPreferredCity.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $newsletterTandC = _self.$newsletterCheckbox.is(':checked');

			if (!$newsletterTandC){
				let $newsletterTandCValidate:any = _self.$newsletterCheckbox.attr('data-tandc');
				this.$newsletterError.push('<strong>'+_self.$newsletterCheckbox.parent().parent().find('.booking-form--title').text()+':</strong> '+$newsletterTandCValidate);
				_self.$newsletterCheckbox.parent().addClass('has-error');
			} else {
				_self.$newsletterCheckbox.parent().removeClass('has-error');
			}

			let $validationContainer:any = _self.$newsletterValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$newsletterError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$newsletterError[i] + '</li>');
			}

			if (this.validateEmail($newsletterEmail) || _self.$newsletterEmailInput.val() != '' || _self.$newsletterPreferredCity.val() != '' || $newsletterTandC){
				if (!($('.newsletterPreferredCity .selectize-control .selectize-input').hasClass('has-error') || $('.newsletterEmail .booking-form--title').hasClass('has-error') || $('#newsletterTandC').parent().hasClass('has-error'))){
					_self.$newsletterErrorValidation.hide();
					let prefCity:string = $('#newsletterPreferredCity').val();

					if (prefCity == '' || prefCity == undefined){
						prefCity=$('#newsletterPreferredCity-js').val();
					}
					_self.submitNewsletterForm($newsletterEmail, prefCity);
					Cookies.set('newsletter-success', true, {expires: 365});
				}
			}
		});
	}

	newsletterFormSelect() {
		$('#recipient__countrycallingcode').selectize();
		$('#recipient_location__countryCode').selectize();
		$('#recipient__podepone').selectize();
		$('#recipient__podeptwo').selectize();
		$('#recipient__podepthree').selectize();
	}

	readValueFromCookie(name:string):any {
		var json="";
		var ca = document.cookie.split(';');

		name = name + "=";

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length,c.length);
			};
		}
		return json;
	}
}

let scope:Element = document.querySelector('.newsletter-popup');
if (scope){
	try {
		let bookingformcommon = new bookingFormCommon();
		let newsletterwidget = new newsletterWidget();

		$.when(window['ibeOnDList']).done((listData: any) => {
			console.log('%cc014newsletter%c ond done', 'background-color: yellow', 'background-color: initial');
			let listItems:string = bookingformcommon.parseNewsletterListItems(listData);
			newsletterwidget.initSelectize(listItems);

		});
		newsletterwidget.newsletterPopUpInit();
		newsletterwidget.newsletterForm();
	} catch(e) {console.error(e);}
}
